import { Box } from "@mui/material";

import { useEffect, useState } from "react";

import PolicyUpdateForm from "./form";
import { HRService } from "../../../../config";
import { AllPoliciesColumns, CompanyCalendarSetupsColumns } from "../../../../data/Columns/hrmanagement";
import { allPolicies, companyCalendarSetups } from "../../../../data/Queries/HRmanagement/leavemanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import CalendarSetupForm from "./form";

const base_url = HRService.uri;
const actions = {
  entity: "Company Calendar Setups",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  markTask: {
    key: "MARK_TASK_DONE",
    button_name: "Mark Task Done",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: true,
};
function CalendarSetupTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Company Calendar Setups"
          subtitle="View all calendar setups , create and edit"
          columns={CompanyCalendarSetupsColumns}
          FormComponent={CalendarSetupForm}
          actions={actions}
          query={companyCalendarSetups}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default CalendarSetupTable;
